/*
 *
 * FlowTemplate
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 05-Sep-2024
 */

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  'closeModal.title': (
    <PortalMessage
      id='t.app.closeModal.title'
      defaultMessage='Sei sicuro di voler interrompere il processo?'
    />
  ),
  'closeModal.description': (
    <PortalMessage
      id='t.app.closeModal.description'
      defaultMessage='Se interrompi ora, tutti i dati inseriti andranno persi.'
    />
  ),
  'closeModal.primaryButtonLabel': (
    <PortalMessage id='t.app.closeModal.primaryButton' defaultMessage='Interrompi' />
  ),
  'closeModal.secondaryButtonLabel': (
    <PortalMessage id='t.app.cancel' defaultMessage='Annulla' />
  ),
  copyrightLabel:
  <PortalMessage
    id='t.app.login.loginPage.copyright.label'
    defaultMessage='© Nexi Payments S.p.A. 2017-2026. All Rights Reserved. - Membro del Gruppo IVA Nexi P.IVA 10542790968'
  />,
  transparency: (
    <PortalMessage
      id='t.app.footer.transparency'
      defaultMessage='Trasparenza'
    />
  ),
  privacy: (
    <PortalMessage
      id='t.app.footer.privacy'
      defaultMessage='Privacy'
    />
  ),
  cookies: (
    <PortalMessage
      id='t.app.footer.cookies'
      defaultMessage='Cookie policy'
    />
  ),
  siteMap: (
    <PortalMessage
      id='t.app.sitemap.title'
      defaultMessage='Mappa del sito'
    />
  )
}

export default formattedMessage
